import { useState } from "react";
import { useStore } from "store";
import { useWindowDimensions } from "resources/BrowserManager";
// import strings from "resources/strings";
import {
  Flex,
  Space,
  Typography,
  Button,
  Modal,
  Dropdown,
  Alert,
  Tooltip,
  message,
  theme,
} from "antd";

import {
  DownOutlined,
  InfoCircleFilled,
  SendOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

import "./style.scss";

import { TextLine } from "../index";

import { TooltipFeatureUnavailable } from "components/Shared/CfdiElements";

export default function ModalRequestCfdi({
  showIcon,
  useSmallButton,
  useTextButton,
}) {
  const { token: theme_token } = theme.useToken();
  const { isSmallView } = useWindowDimensions();
  const user = useStore((state) => state.user);

  const activeRfc = useStore((state) => state.activeRfc);

  const active_rfc_obj = ["nuevo-rfc", "onboarding"].includes(activeRfc)
    ? null
    : user.rfcs[activeRfc];

  const csf = active_rfc_obj.sat_csf?.data;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRegimen, setSelectedRegimen] = useState(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsLoading(false);
    setIsModalOpen(false);
    setSelectedRegimen(null);
  };

  const handleConfirmation = async () => {
    setIsLoading(true);

    const selectedRegimenText =
      csf?.regimenes?.length === 1
        ? csf?.regimenes[0].regimen
        : selectedRegimen;

    const shareData = {
      text: `Se le ha enviado una solicitud de CFDI con los siguientes datos:\n\n\tRFC: ${csf?.identificacion.rfc}\n\tNombre Fiscal: ${csf?.identificacion.nombre_fiscal}\n\tCódigo Postal Fiscal: ${csf?.domicilio.codigo_postal}\n\tRégimen: ${selectedRegimenText}\n\nFavor de enviar el CFDI al correo: ${user.email}\n\n\n\nAdministra tu facturación con https://factu.mx`,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        handleCancel();
      } catch {
        // User cancelled share sheet, reactivate modal controls
        setIsLoading(false);
      }
    } else {
      await navigator.clipboard.writeText(shareData.url);
      message.success("Tus datos se copiaron al clipboard.");
      setIsLoading(false);
    }
  };

  const dropdownMenuProps = {
    items:
      csf?.regimenes?.length > 1
        ? csf?.regimenes?.map((i) => ({
            key: i.regimen,
            label: i.regimen,
          }))
        : [],
    onClick: (v) => setSelectedRegimen(v.key),
  };

  const DropdownRegimen = () => (
    <Dropdown
      trigger={["click"]}
      placement="bottomLeft"
      overlayStyle={{ maxWidth: 400 }}
      menu={{
        ...dropdownMenuProps,
        items: dropdownMenuProps.items?.map((item) => ({
          ...item,
          label: (
            <div
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.4,
              }}
            >
              {item.label}
            </div>
          ),
        })),
      }}
    >
      <Button
        block
        style={{
          height: "auto",
          textAlign: "left",
          paddingTop: 6,
          paddingBottom: 6,
        }}
      >
        <Flex
          justify="space-between"
          align="flex-start"
          style={{ width: "100%" }}
        >
          <span
            style={{
              flex: 1,
              minWidth: 0,
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {csf?.regimenes?.length > 1
              ? selectedRegimen || "Seleccionar Régimen"
              : csf?.regimenes[0].regimen}
          </span>
          {csf?.regimenes?.length > 1 && (
            <DownOutlined style={{ marginTop: 4 }} />
          )}
        </Flex>
      </Button>
    </Dropdown>
  );

  const SectionRegimen = () => (
    <Flex vertical gap={3}>
      {csf?.regimenes?.length > 1 ? (
        <Text>Selecciona el Régimen que deseas usar:</Text>
      ) : (
        <Text>Se usará el único Régimen que tienes activo:</Text>
      )}
      <DropdownRegimen />
    </Flex>
  );

  const ButtonRequestCfdi = () => {
    const buttonContainer =
      isSmallView && useSmallButton ? (
        <Flex vertical align="center" gap={8}>
          <Button
            type="primary"
            onClick={showModal}
            icon={showIcon && <SendOutlined />}
            disabled={csf == null}
            size="middle"
            style={{
              borderRadius: "50%",
              width: 50,
              height: 50,
            }}
          />
          <Text
            style={{
              width: 53, //enough to show a full word
              textAlign: "center",
              whiteSpace: "normal",
              wordBreak: "normal",
              overflowWrap: "break-word",
              lineHeight: 1.2,
            }}
          >
            Solicitar CFDI
          </Text>
        </Flex>
      ) : useTextButton ? (
        <Text
          onClick={showModal}
          style={{
            textDecoration: "underline dotted",
            cursor: "pointer",
            color: theme_token.colorPrimary,
            textWrap: "nowrap",
          }}
        >
          Solicitar CFDI
        </Text>
      ) : (
        <Button
          type="primary"
          onClick={showModal}
          icon={showIcon && <SendOutlined />}
          disabled={csf == null}
        >
          Solicitar CFDI
        </Button>
      );

    return csf ? (
      buttonContainer
    ) : active_rfc_obj.plan_name === "free" ? (
      <TooltipFeatureUnavailable requiredPlans={["pro", "basic"]}>
        {buttonContainer}
      </TooltipFeatureUnavailable>
    ) : (
      <Tooltip title={"La información de tu perfil fiscal se está cargando."}>
        {buttonContainer}
      </Tooltip>
    );
  };

  return (
    <>
      <ButtonRequestCfdi />
      <Modal
        title="Solicitar CFDI"
        open={isModalOpen}
        onOk={handleConfirmation}
        onCancel={handleCancel}
        width={860}
        destroyOnClose={true}
        footer={null}
        maskClosable={!!!isLoading}
        closable={!!!isLoading}
      >
        <Flex vertical gap={30} style={{ marginTop: "20px" }}>
          <Alert
            description={
              <Space size={10}>
                <InfoCircleFilled
                  style={{ fontSize: "18px", color: "#1677ff" }}
                />
                <Text>
                  Por disposición legal del SAT, la Constancia de Situación
                  Fiscal (CSF) es un documento confidencial y no es necesario
                  compartirlo para solicitar facturas electrónicas (CFDI).
                </Text>
              </Space>
            }
            type="info"
            style={{ padding: "15px" }}
          />
          <Flex vertical gap={10}>
            <Text>
              Solicita un nuevo CFDI, el destinatario sólo recibirá la siguiente
              información:
            </Text>
            <Flex vertical gap={isSmallView ? 5 : 0}>
              <TextLine
                label="Nombre Fiscal"
                values={[csf?.identificacion.nombre_fiscal]}
                wrap
              />
              <TextLine label="RFC" values={[csf?.identificacion.rfc]} />
              <TextLine
                label="Código Postal Fiscal"
                values={[csf?.domicilio.codigo_postal]}
              />
            </Flex>
            <SectionRegimen />
          </Flex>
          <Flex
            vertical={isSmallView}
            justify={isSmallView ? null : "flex-end"}
          >
            <Button
              type="primary"
              icon={<SendOutlined />}
              onClick={handleConfirmation}
              loading={isLoading}
              disabled={csf?.regimenes?.length > 1 ? !selectedRegimen : false}
            >
              Solicitar CFDI
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
}
